"use client";

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { ThemeProvider } from '@/components/theme-provider';
import { UserProvider } from '@/context/userContext';

/**
 * Providers component that wraps the application with necessary context providers.
 * Currently includes:
 * - TanStack Query for server state management
 * - Theme provider for dark/light mode
 */
export function Providers({ children }: { children: React.ReactNode }) {
  // Create a query client instance that persists across renders but is unique for each user
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5, // 5 minutes
        retry: 1,
      },
    },
  }));

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider
        attribute="class"
        defaultTheme="light"
        enableSystem
        disableTransitionOnChange
      >
        <UserProvider>
          {children}
        </UserProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
} 